import { List } from 'immutable';
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseEntity, BaseInlineContainer, DefaultButtonsConfig, InlineContainerService, UserService} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { FakDokumentStavkaInlineUpdateComponent } from './fak-dokument-stavka-inline-update.component';

//import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'yt-fak-dokument-stavka-update-container',
  templateUrl: './fak-dokument-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class FakDokumentStavkaUpdateContainer<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
              activatedRoute: ActivatedRoute,
              userService: UserService,
              ){
super(inlineContainerService, activatedRoute, userService);
}
  @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

  tempItems: List<T>
  
  //setItems(items){
  //  this.tempItems = items;
  //}

  //@ViewChild("baseDetailList", { static: false }) baseDetailList: any;

  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
    }
  }
  setItems(items) {
    this.tempItems = items;
    }


  }


